export default "__VITE_ASSET__BgJNXsYq__"